<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:00em;">My husband, Tom, a biblical scholar and archaeologist, encouraged me to write this little book.</p>
<br/><p style="text-indent:00em;">Agatha Christie wrote that an archaeologist is the best husband any woman could have because the older she gets the more interested he is in her.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?716a56f0